import { cast, Instance, types } from 'mobx-state-tree'
import { ForDirectExtend } from '../../../features/mobx'

const _StemSettingsStore = types
  .model({
    stemGain: 1,
    arrangement: types.array(types.number)
  })
  .actions((self) => {
    function initialize(arrangementLength: number) {
      self.arrangement = cast(Array(arrangementLength).fill(0))
    }
    function setStemGain(stemGain: number) {
      self.stemGain = stemGain
    }
    function setArrangement(index, value) {
      self.arrangement[index] = value
    }
    function setEntireArrangement(arrangement) {
      self.arrangement = arrangement
    }
    function extendArrangement() {
      self.arrangement.push(0)
    }
    // Shrinks the arrangement array by removing any trailing 0s.
    function trimArrangement() {
      let zerosAtEnd = 0
      for (let i = self.arrangement.length - 1; i >= 0; i--) {
        if (self.arrangement[i] === 0) {
          zerosAtEnd++
        } else {
          break
        }
      }
      trimArrangementTo(self.arrangement.length - zerosAtEnd)
    }
    function trimArrangementTo(length: number) {
      self.arrangement = cast(self.arrangement.slice(0, length))
    }
    return {
      initialize,
      setArrangement,
      setEntireArrangement,
      setStemGain,
      trimArrangement,
      trimArrangementTo,
      extendArrangement
    }
  })

interface StemSettingsStoreType extends ForDirectExtend<typeof _StemSettingsStore> {}
export const StemSettingsStore: StemSettingsStoreType = _StemSettingsStore

export interface IStemStore extends ForDirectExtend<Instance<typeof StemSettingsStore>> {}
